import React, {Component} from "react";

import {
	Jumbotron,
	Alert, Row, Col
} from 'reactstrap';


import $ from 'jquery';

import Nav from '../../components/nav/Nav';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";

import {
	getDocumentsResponse,
	getDocuments
} from '../../actions/documents';

import {
	getDocuments as getDocumentsService
} from '../../services/document';

import Spinner from '../../components/spinner/Spinner';
import env from "../../env";


class List  extends Component{

	constructor(props) {

		super(props);

		this.state = {
			list: [],
			loading: true,
			site: null,
			archived: false,
			root_id: null,
			keyword: '',
			document_type_id: '',
			subcat: '',
			cat: '',
			error: null
		};
	}

	componentWillReceiveProps(nextProps){
		const {loading, error, list} = nextProps.documents;

		this.setState({loading,error,list});
	}


	componentDidMount(){

		const {loggedIn, site} = this.props.account;

		if(!loggedIn){
			this.props.history.push(`${env.url}/login`);
		}

		if(site === null || !site)
			this.props.history.push(`${env.url}/`);

		this.setState({
			site
		});

		this.fetch(site);

	}

	initJQuery = () => {

		let that = this;

		var File = function(){

			function viewFolder(id) {
				that.fetch(null, id);
			};

			/**
			 * Handle view folder button clicks
			 */
			function initViewFolder(){
				$(document).on('click', '.view-folder', function(e) {
					e.preventDefault();
					viewFolder($(this).data('id'));
				});
			}


			function initLoadMore(){
				$(document).on('click', '.load-more', function(e){
					e.preventDefault();
					var button = $(this);
					button.html('Loading...').prop('disabled', true);

					that.fetch(null, button.data('root'), {page: button.data('page')})
				});
			}

			/**
			 * Main function
			 */
			return {
				init : function(){
					initViewFolder();
					initLoadMore();
				},
				viewFolder: viewFolder
			}
		}();

		$(function(){
			File.init();
		});
	};

	buildQuery = (query, param, value) => {
		if (value !== null && value !== undefined && value !== '') {
			if (!query){
				return `?${param}=${value}`;
			}else{
				query += `&${param}=${value}`;
				return query;
			}
		}

		return query;
	};

	fetch = (site, root_id, options = {}) => {

		const props = this.props;
		props.getDocuments();
		let query = '';

		const {
			keyword,
			document_type_id,
			subcat,
			cat,
			archived,
		} = this.state;

		const values = {...{
			keyword,
			document_type_id,
			subcat,
			cat,
			archived,
		}, ...options};

		query = this.buildQuery(query, 'root_id', root_id);
		query = this.buildQuery(query, 'keyword', values.keyword);
		query = this.buildQuery(query, 'document_type_id', values.document_type_id);
		query = this.buildQuery(query, 'subcat', values.subcat);
		query = this.buildQuery(query, 'cat', values.cat);


		if (values.archived) {
			query = this.buildQuery(query, 'archived', values.archived);
		}

		if (values.page) {
			query = this.buildQuery(query, 'page', values.page);
		}

		const mine = site ? site: this.state.site;

		if(mine === null || !mine)
			this.props.history.push(`${env.url}/`);

		getDocumentsService({id: mine.id, query}).then(function(resp){
			props.getDocumentsResponse(resp);
		}).catch(function(e){
			console.log(e);
		});

		this.initJQuery();
	};

	onChange = (event) => {
		let value = event.target.value;
		let name = event.target.name;

		this.setState({
			[name]: value,
		});

		this.fetch(null, this.state.root_id, {[name]: value});
	};

	onCheckBox = (event, name) => {
		this.setState({
			[name]: event.target.checked,
		});

		this.fetch(null, this.state.root_id, {[name]: event.target.checked});
	};

	render(){

		const {
			loading,
			site,
			error,
			list,
			keyword,
			document_type_id,
			subcat,
			cat,
			archived,
		} = this.state;

		const {data, html} = list;
		let text = '';

		if (html) {
			text = html.replaceAll('fa fa-file-alt', 'fa fa-file');
			text = text.replaceAll('fas fa-info', 'fa fa-info');
		}

		const bold = {
			fontFamily: 'PT Sans Narrow',
			fontWeight: '700',
			fontSize: '16px',
			lineHeight: '7px',
		};

		return(
			<div className="checklists">
				<Nav
					history={this.props.history}
					location={this.props.location}/>
				{
					error?
						<Alert color="danger">{error}</Alert>:null
				}


				{
					loading?
						<Spinner/>
						:
						(
							<div>
								<Jumbotron>
									<p className="lead">
										{site? site.name : ''} Documents
									</p>
									<hr className="my-2" />
								</Jumbotron>

								<div className="inner">

									<div>
										<div style={{
											backgroundColor: '#fafafa',
											margin: '15px 0',
											padding: '10px',
										}}>
											<Row>
												<Col>
													{
														data.category_ids && Object.keys(data.category_ids).length?
															<div className="form-group">
																<label
																	htmlFor="template_id"
																	className="control-label">
																	Compliance Standard
																</label>
																<select
																	value={cat}
																	onChange={this.onChange}
																	className="selectpicker form-control"
																	id="cat"
																	name="cat">
																	<option value="">Select an option</option>
																	{
																		Object.keys(data.category_ids).map(key => <option key={key} value={key}>{data.category_ids[key]}</option>)
																	}
																</select>

															</div>: null
													}

												</Col>
											</Row>
											<Row>
												<Col>
													{
														data.arr_document_types && Object.keys(data.arr_document_types).length?
															<div className="form-group">
																<label
																	htmlFor="user_id"
																	className="control-label">
																	Document Type
																</label>
																<select
																	value={document_type_id}
																	onChange={this.onChange}
																	className="selectpicker form-control"
																	id="document_type_id"
																	name="document_type_id">
																	<option value="">Select an option</option>
																	{
																		Object.keys(data.arr_document_types).map(key => <option key={key} value={key}>{data.arr_document_types[key]}</option>)
																	}
																</select>
															</div> : null
													}

												</Col>
											</Row>
											<Row>
												<Col>
													{
														data.sub_categories && Object.keys(data.sub_categories).length?
															<div className="form-group">
																<label
																	htmlFor="user_id"
																	className="control-label">
																	Sub Category
																</label>
																<select
																	value={subcat}
																	onChange={this.onChange}
																	className="selectpicker form-control"
																	id="subcat"
																	name="subcat">
																	<option value="">Select an option</option>
																	{
																		Object.keys(data.sub_categories).map(key => <option key={key} value={key}>{data.sub_categories[key]}</option>)
																	}
																</select>
															</div> : null
													}
												</Col>
											</Row>
											<Row>
												<Col style={{display: 'none'}}>
													<div className="form-group">
														<label
															htmlFor="user_id"
															className="control-label">
															Search Name
														</label>
														<input
															value={keyword}
															onChange={this.onChange}
															id="search"
															className="form-control"
															type="text"
															name="keyword"
															placeholder="Search..."/>
													</div>
												</Col>
											</Row>
											<Row style={{display: 'none'}}>
												<Col>
													<label className="control-label archived-label"
													       htmlFor="archived-toggle">
														<input checked={archived} onChange={(event) => this.onCheckBox(event, 'archived')} type="checkbox" className="form-control"
														        name="archived-toggle" id="archived-toggle" data-id=""/>
															Include Archived &nbsp;<span className="glyphicon glyphicon-repeat normal-right-spinner"/>
													</label>
												</Col>
											</Row>
										</div>
									</div>
									<div id="content" className="documents">
										<div id="documents-holder" dangerouslySetInnerHTML={{__html: text}}/>
									</div>
								</div>
							</div>
						)
				}

			</div>
		)
	}
}


const mapStateToProps = ({ account, documents}) => ({
	account,
	documents
});

const mapDispatchToProps = dispatch => bindActionCreators({
	getDocumentsResponse: (resp) => getDocumentsResponse(resp),
	getDocuments: () => getDocuments()
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(List)




// WEBPACK FOOTER //
// ./src/screens/documents/List.js